module.exports = __webpack_public_path__ + "img/frame (23).2bdc8672.jpg";